import PropTypes from "prop-types";
import { childrenPropType, titlePropType, onClosePropType, classNamePropType, appearancePropType } from "../../common";

/**
 * PropTypes for Alert component
 *
 * @property {('default'|'primary'|'secondary'|'success'|'danger'|'warning'|'info')} [appearance] - Visual style variant
 * @property {string} [title] - Alert title text
 * @property {React.ReactNode} [children] - Alert content/message
 * @property {string} [className] - Additional CSS classes
 * @property {function} [onClose] - Close button handler
 * @property {boolean} [dismissible] - Show close button
 * @property {React.ReactNode} [icon] - Custom icon element
 */
export const alertPropTypes = {
  appearance: appearancePropType,
  title: titlePropType,
  children: childrenPropType,
  className: classNamePropType,
  onClose: onClosePropType,
  dismissible: PropTypes.bool,
  icon: PropTypes.node,
};
